import React from 'react';
export function Footer() {
  return <footer className="py-[56px] md:py-[80px] px-5 bg-[#0F2340] text-center" data-id="element-84">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-6" data-id="element-85">
        <div className="flex flex-wrap justify-center gap-4 text-gray-400 text-sm" data-id="element-86">
          <a href="#" className="hover:text-white transition-colors" data-id="element-87">
            Términos y Condiciones
          </a>
          <span className="text-gray-600" data-id="element-88">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-89">
            Política de Privacidad
          </a>
          <span className="text-gray-600" data-id="element-90">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-91">
            Contacto
          </a>
        </div>
        <p className="text-gray-500 text-sm" data-id="element-92">
          © 2026 Mesas Epoxi Pro — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}